import { render, staticRenderFns } from "./TooltipDeptos.vue?vue&type=template&id=c8ed39d6"
import script from "./TooltipDeptos.vue?vue&type=script&lang=js"
export * from "./TooltipDeptos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports